// How many presses an external action takes (decided 2026-10-12, Chris): reversible mailbox
// changes run on one press with Undo; everything irreversible or outward-facing (sends, replies,
// forwards, calendar writes, unsubscribes, routine batches) keeps arm → confirm. Either way the
// gateway creates, binds and verifies the same digest-bound approval; only the number of presses
// in the web differs. Shared by the server and the web, with no runtime dependencies so the web
// bundle stays zod-free.

/**
 * Changes inside the owner's own mailbox that have an exact reverse: archive ↔ move back to the
 * inbox, and a label delta ↔ the swapped delta (read/unread, star and labels are all deltas).
 * These are also the thread actions the owner may start from the inbox views without a card.
 */
export const REVERSIBLE_ACTION_KINDS = [
  "gmail.archive_thread",
  "gmail.unarchive_thread",
  "gmail.label",
] as const;

export type ReversibleActionKind = (typeof REVERSIBLE_ACTION_KINDS)[number];

const REVERSIBLE: ReadonlySet<string> = new Set(REVERSIBLE_ACTION_KINDS);

/** True for a kind that runs on one press with Undo; false (arm → confirm) for anything else. */
export function isReversibleActionKind(
  kind: string | null | undefined,
): kind is ReversibleActionKind {
  return !!kind && REVERSIBLE.has(kind);
}
